
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#D6DBEA","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.347 52.714h50.766M12.969 30.641v22.073m37.522 0V30.641M32.392 12.366a1.103 1.103 0 00-1.311 0L9.04 28.65a1.103 1.103 0 00.662 1.986h44.06a1.103 1.103 0 00.662-1.986L32.392 12.366z"}}),_c('path',{attrs:{"d":"M50.491 25.766v-9.471c0-.61-.494-1.104-1.103-1.104h-4.415c-.61 0-1.103.494-1.103 1.104v4.585M28.419 48.3v-9.933c0-.61-.494-1.104-1.104-1.104h-6.621c-.61 0-1.104.494-1.104 1.104v9.932m15.451-11.036h11.036v8.829H35.041z"}}),_c('path',{attrs:{"d":"M17.383 52.714v-3.311c0-.61.494-1.104 1.104-1.104h11.036c.61 0 1.103.494 1.103 1.104v3.31"}})])])
          )
        }
      }
    